export default () => ({
  invoice: null
})
